/**
 * /shop/ filter form event normalizer.
 *
 * Translates raw form interactions into a single `shop:filter-change`
 * event on the form. The shop-ajax driver listens for that event and
 * owns everything else (fetch / pushState / fragment swap).
 *
 * Inputs translated:
 *   • Any checkbox flip (Category, Trademark, In stock)
 *     dispatches immediately.
 *   • The toolbar SHOW / SORT selects (per_page, sort) dispatch on
 *     change. These live outside the <form> DOM tree (in the catalog
 *     header) and are associated via the `form="tx-shop-filter-form"`
 *     attribute, so a form-level listener won't catch them — they're
 *     wired with a dedicated document-level listener below.
 *   • A form submit (Enter in the search input, or click on the
 *     submit-arrow button) dispatches and then preventDefault's the
 *     native submission so the page doesn't reload.
 *
 * Text inputs are deliberately NOT auto-fired — the search field
 * commits only on Enter / button, so the user isn't interrupted
 * mid-type by every keystroke.
 *
 * No-JS fallback: with this script absent, the form's native
 * method="get" / action="/shop/" submission still loads the
 * SSR-rendered filtered page.
 */
const dispatchFilterChange = (form) => {
    form.dispatchEvent(new CustomEvent('shop:filter-change', { bubbles: true }));
};

const init = () => {
    const form = document.querySelector('[data-shop-filter-form]');
    if (!form) return;

    form.addEventListener('change', (e) => {
        const t = e.target;
        if (t && t.tagName === 'INPUT' && t.type === 'checkbox' && !t.disabled) {
            dispatchFilterChange(form);
        }
    });

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        dispatchFilterChange(form);
    });

    // Toolbar selects (SHOW / SORT) sit in the catalog header,
    // outside the filter form. The `form="<id>"` attribute makes
    // them serialize WITH the form, but their `change` events
    // don't bubble to the form element, so we listen on document.
    document.querySelectorAll('[data-shop-toolbar-select]').forEach((sel) => {
        sel.addEventListener('change', () => {
            if (!sel.disabled) dispatchFilterChange(form);
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
